var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 128 128",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flat"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Color"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m62.514 6.563v14a1.5 1.5 0 0 0 3 0v-14a1.5 1.5 0 1 0 -3 0z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.619 65.142a40.551 40.551 0 0 1 5.7-20.624 17.28 17.28 0 0 0 -10.8 4.6c-4.2 4.181-4.38 9.647-4.646 17.565-.279 8.117-.458 13.461 3.401 17.663 3.758 4.312 8.929 4.579 13.867 4.3a40.927 40.927 0 0 1 -7.522-23.504z",
    fill: "#ffa000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m126.132 66.681c-.266-7.918-.45-13.384-4.646-17.565a17.28 17.28 0 0 0 -10.8-4.6 40.341 40.341 0 0 1 -1.827 44.124c4.948.281 10.1.018 13.867-4.3 3.859-4.196 3.68-9.54 3.406-17.659z",
    fill: "#ffa000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m116.381 65.142c0-25.129-23.452-45.5-52.381-45.5s-52.381 20.371-52.381 45.5c0 19.912 14.731 36.825 35.238 42.994-1.44 2.9-3.736 5.546-6.782 9.131a5.5 5.5 0 0 0 5.585 8.88 56.9 56.9 0 0 0 27.01-16.136c24.801-3.591 43.711-22.306 43.711-44.869z",
    fill: "#ffc107"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 6.5,
    fill: "#424242",
    r: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64 27.142c-24.678 0-42.238 21.43-39.641 45.742a18.121 18.121 0 0 0 17.966 16.258c10.838-.03 10.838-6.049 21.675-6.049s10.837 6.019 21.675 6.049a18.121 18.121 0 0 0 17.966-16.258c2.597-24.312-14.963-45.742-39.641-45.742z",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m73.224 61.892a4.562 4.562 0 0 0 -6.357.036 3.591 3.591 0 0 1 -5.663.007 4.5 4.5 0 0 0 -6.41 6.319 12.57 12.57 0 0 0 18.475 0 4.53 4.53 0 0 0 -.045-6.362z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m85.5 47.814a4.57 4.57 0 0 0 -4.5-4.672 4.516 4.516 0 0 0 -4.5 4.5v7a4.505 4.505 0 0 0 4.5 4.5 4.559 4.559 0 0 0 4.5-4.671c0-1.664 0-4.993 0-6.657z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47 43.142a4.568 4.568 0 0 0 -4.5 4.672c.005 1.664.005 4.993 0 6.657a4.569 4.569 0 0 0 4.5 4.671 4.515 4.515 0 0 0 4.5-4.5v-7a4.516 4.516 0 0 0 -4.5-4.5z"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 94.142,
    fill: "#424242",
    r: 4.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.ce494b3f1022990cc8486272d17aaec3.svg";
export { ForwardRef as ReactComponent };